import { render, staticRenderFns } from "./Boxplot.vue?vue&type=template&id=85044a94"
import script from "./Boxplot.vue?vue&type=script&lang=js"
export * from "./Boxplot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports